export default "__VITE_ASSET__D02WW$Yn__"